export default function CarouselController(module) {
    angular.module(module || 'app').controller('CarouselController', CarouselController);
    CarouselController.$inject = ['$scope', '$element', '$window'];

    function CarouselController($scope, $element, $window) {
        var ctrl = this;

        ctrl.blog = {
            spacing: { small: 16, medium: 58, large: 58 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                return {};
            }
        };
        ctrl.videos = {
            spacing: { small: 16, medium: 58, large: 58 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    pointerEvents: indexDiff === 0 ? '' : 'none',
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        };
        ctrl.products = {
            spacing: { small: 16, medium: 58, large: 58 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    //pointerEvents: indexDiff >= 0 && indexDiff <= slideCount - 1 ? '' : 'none',
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        };
        ctrl.reviews = {
            spacing: { small: 16, medium: 92, large: 92 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    pointerEvents: indexDiff === 0 ? '' : 'none',
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        };
        ctrl.images = {
            spacing: { small: 16, medium: 92, large: 92 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    pointerEvents: indexDiff === 0 ? '' : 'none',
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        };
        ctrl.caseStudies = {
            spacing: { small: 16, medium: 32, large: 48 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        }
        ctrl.services = {
            spacing: { small: 16, medium: 32, large: 48 },
            slideWidth: 1,
            slideStyles: function (indexDiff, slideCount) {
                var opacity = ((indexDiff < 0 ? indexDiff : (indexDiff - slideCount + 1)) * .5);
                return {
                    opacity: indexDiff < 0 ? 1 + opacity : 1 - opacity
                };
            }
        }
    }
};